import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchAdvisors, createAdvisor, addAdvisorsToRoom } from '@/api/advisor'
import { cloneAdvisor } from '@/api/configuration'
import { Advisor } from '../types/advisor'

export const fetchAdvisorsThunk = createAsyncThunk<
  Advisor[],
  { roomId: string; playerId?: string },
  { rejectValue: string }
>('advisor/fetchAdvisors', async ({ roomId, playerId }, thunkAPI) => {
  try {
    const response = await fetchAdvisors(roomId, playerId)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue((error as Error).message)
  }
})
export const createAdvisorThunk = createAsyncThunk<
  Advisor,
  { advisorData: string; roomId: string },
  { rejectValue: string }
>('advisor/createAdvisor', async ({ advisorData, roomId }) => {
  // create advisor
  const advisorResponse = await createAdvisor(advisorData)
  const advisor = advisorResponse.data

  // link advisor to room
  await addAdvisorsToRoom(roomId, [advisor.chatbotid])

  return advisor
})

export const cloneAdvisorThunk = createAsyncThunk<
  Advisor,
  { chatbotid: string },
  { rejectValue: string }
>('advisor/cloneAdvisor', async ({ chatbotid }, thunkAPI) => {
  try {
    const response = await cloneAdvisor(chatbotid)
    return response.data
  } catch (error) {
    return thunkAPI.rejectWithValue((error as Error).message)
  }
})
